import React, { Component } from "react";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import { message, Popconfirm, Tooltip, Select, Space } from "antd";
import {
  EditOutlined,
  CheckOutlined,
  CloseOutlined,
  PlusOutlined,
  CheckCircleOutlined,
  StopOutlined,
} from "@ant-design/icons";
import {
  ModalItem,
  TableItem,
  ButtonItem,
  InputItem,
  InputNumberItem,
  DatePickerItem,
  SegmentedItem,
} from "../../../../Components/Items";

const { Option } = Select;

const TIPO_DATO_LABEL = {
  numero: "Número",
  texto: "Texto",
  fecha: "Fecha",
  booleano: "Booleano",
};

const formatearValor = (valor, tipoDato) => {
  if (valor === null || valor === undefined || valor === "") return "—";
  if (tipoDato === "booleano") return valor ? "Sí" : "No";
  if (tipoDato === "fecha") {
    const m = moment(valor);
    return m.isValid() ? m.format("DD/MM/YYYY") : String(valor);
  }
  return String(valor);
};

class ModalValores extends Component {
  state = {
    loading: false,
    valores: [],
    nuevoValor: null,
    nuevaUnidad: "",
    editandoId: null,
    valorEditando: null,
    unidadEditando: "",
    filtroEstado: 1,
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.visible !== this.props.visible &&
      this.props.visible &&
      this.props.categoria
    ) {
      this.setState(
        {
          nuevoValor: null,
          nuevaUnidad: "",
          editandoId: null,
          valorEditando: null,
          unidadEditando: "",
          filtroEstado: 1,
          valores: [],
        },
        () => this.consultarValores()
      );
    }
  }

  consultarValores = async () => {
    if (!this.props.categoria) return;
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        "valoresCategoriaInsumo/selectValoresPorCategoria",
        {
          categoriaInsumoId: this.props.categoria._id,
          valor: this.state.filtroEstado,
        },
        { headers: this.props.headersToken }
      );
      if (res.data && res.data.success === 2) {
        this.setState({ valores: res.data.valores || [] });
      } else {
        this.setState({ valores: [] });
      }
    } catch (err) {
      console.error("Error al consultar valores:", err);
      this.setState({ valores: [] });
    } finally {
      this.setState({ loading: false });
    }
  };

  serializarParaBackend = (valor) => {
    if (!this.props.categoria) return valor;
    if (this.props.categoria.tipoDato === "fecha") {
      return moment.isMoment(valor) ? valor.toISOString() : valor;
    }
    return valor;
  };

  agregarValor = () => {
    const { nuevoValor } = this.state;
    if (
      nuevoValor === null ||
      nuevoValor === undefined ||
      (typeof nuevoValor === "string" && nuevoValor.trim() === "")
    ) {
      message.warning("Ingresa un valor");
      return;
    }

    this.setState({ loading: true });
    axios
      .post(
        "valoresCategoriaInsumo/agregarValorCategoria",
        {
          categoriaInsumoId: this.props.categoria._id,
          empresaId: this.props.empresaId,
          valor: this.serializarParaBackend(nuevoValor),
          unidad: this.state.nuevaUnidad || "",
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data && res.data.success === 2) {
          message.success("Valor agregado");
          this.setState({ nuevoValor: null, nuevaUnidad: "" });
          this.consultarValores();
        } else {
          this.setState({ loading: false });
          message.error((res.data && res.data.message) || "No se pudo agregar el valor");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al agregar valor");
      });
  };

  iniciarEdicion = (record) => {
    let valor = record.valor;
    if (this.props.categoria?.tipoDato === "fecha" && valor) {
      valor = moment(valor);
    }
    this.setState({
      editandoId: record._id,
      valorEditando: valor,
      unidadEditando: record.unidad || "",
    });
  };

  cancelarEdicion = () => {
    this.setState({ editandoId: null, valorEditando: null, unidadEditando: "" });
  };

  guardarEdicion = (id) => {
    this.setState({ loading: true });
    axios
      .post(
        "valoresCategoriaInsumo/editarValorCategoria",
        {
          valorCategoriaInsumoId: id,
          empresaId: this.props.empresaId,
          valor: this.serializarParaBackend(this.state.valorEditando),
          unidad: this.state.unidadEditando || "",
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data && res.data.success === 2) {
          message.success("Valor actualizado");
          this.setState({ editandoId: null, valorEditando: null, unidadEditando: "" });
          this.consultarValores();
        } else {
          this.setState({ loading: false });
          message.error((res.data && res.data.message) || "No se pudo editar el valor");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al editar valor");
      });
  };

  deshabilitarValor = (id) => {
    axios
      .post(
        "valoresCategoriaInsumo/deshabilitarValorCategoria",
        { valorCategoriaInsumoId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data && res.data.success === 2) {
          message.success("Valor deshabilitado");
          this.consultarValores();
        } else {
          message.error("No se pudo deshabilitar");
        }
      });
  };

  habilitarValor = (id) => {
    axios
      .post(
        "valoresCategoriaInsumo/habilitarValorCategoria",
        { valorCategoriaInsumoId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data && res.data.success === 2) {
          message.success("Valor habilitado");
          this.consultarValores();
        } else {
          message.error("No se pudo habilitar");
        }
      });
  };

  renderInputValor = (value, onChange, options = {}) => {
    const tipo = this.props.categoria?.tipoDato;
    const style = { width: "100%", ...(options.style || {}) };
    if (tipo === "numero") {
      return (
        <InputNumberItem
          value={value}
          onChange={onChange}
          placeholder="Valor numérico"
          style={style}
        />
      );
    }
    if (tipo === "fecha") {
      return (
        <DatePickerItem
          value={value}
          onChange={onChange}
          format="DD/MM/YYYY"
          style={style}
        />
      );
    }
    if (tipo === "booleano") {
      return (
        <Select
          value={value === null || value === undefined ? undefined : value}
          onChange={onChange}
          placeholder="Seleccionar"
          style={style}
        >
          <Option value={true}>Sí</Option>
          <Option value={false}>No</Option>
        </Select>
      );
    }
    return (
      <InputItem
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Valor"
        style={style}
      />
    );
  };

  render() {
    const { categoria, visible } = this.props;
    if (!categoria) return null;
    const esNumero = categoria.tipoDato === "numero";

    const columns = [
      {
        title: "Valor",
        dataIndex: "valor",
        key: "valor",
        render: (value, record) => {
          if (this.state.editandoId === record._id) {
            return this.renderInputValor(
              this.state.valorEditando,
              (v) => this.setState({ valorEditando: v })
            );
          }
          return formatearValor(value, categoria.tipoDato);
        },
      },
      ...(esNumero
        ? [
            {
              title: "Unidad",
              dataIndex: "unidad",
              key: "unidad",
              width: "18%",
              render: (value, record) => {
                if (this.state.editandoId === record._id) {
                  return (
                    <InputItem
                      value={this.state.unidadEditando}
                      onChange={(e) =>
                        this.setState({ unidadEditando: e.target.value })
                      }
                      placeholder="Ej. Mts, KG"
                    />
                  );
                }
                return value || "—";
              },
            },
          ]
        : []),
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        width: "15%",
        align: "center",
        render: (value) =>
          value === 1 ? (
            <span style={{ color: "#52c41a", fontWeight: 500 }}>Activo</span>
          ) : (
            <span style={{ color: "#999" }}>Deshabilitado</span>
          ),
      },
      {
        title: "Acción",
        key: "acciones",
        align: "center",
        width: "22%",
        onCell: () => ({ className: "acciones-sin-hover" }),
        render: (_, record) => {
          if (this.state.editandoId === record._id) {
            return (
              <Space>
                <Tooltip title="Guardar">
                  <ButtonItem
                    size="small"
                    olivo
                    icon={<CheckOutlined />}
                    onClick={() => this.guardarEdicion(record._id)}
                  />
                </Tooltip>
                <Tooltip title="Cancelar">
                  <ButtonItem
                    size="small"
                    gris
                    icon={<CloseOutlined />}
                    onClick={this.cancelarEdicion}
                  />
                </Tooltip>
              </Space>
            );
          }
          const buttons = [];
          if (this.props.permisoEditarValor) {
            buttons.push(
              <Tooltip key={`edit-${record._id}`} title="Editar">
                <ButtonItem
                  size="small"
                  cyan
                  icon={<EditOutlined />}
                  onClick={() => this.iniciarEdicion(record)}
                />
              </Tooltip>
            );
          }
          if (this.props.permisoHabDesValor) {
            if (record.estado === 1) {
              buttons.push(
                <Popconfirm
                  key={`des-${record._id}`}
                  title="¿Deshabilitar este valor?"
                  onConfirm={() => this.deshabilitarValor(record._id)}
                  okText="Sí"
                  cancelText="No"
                >
                  <Tooltip title="Deshabilitar">
                    <ButtonItem size="small" lima icon={<CheckCircleOutlined />} />
                  </Tooltip>
                </Popconfirm>
              );
            } else {
              buttons.push(
                <Popconfirm
                  key={`hab-${record._id}`}
                  title="¿Habilitar este valor?"
                  onConfirm={() => this.habilitarValor(record._id)}
                  okText="Sí"
                  cancelText="No"
                >
                  <Tooltip title="Habilitar">
                    <ButtonItem size="small" rojo icon={<StopOutlined />} />
                  </Tooltip>
                </Popconfirm>
              );
            }
          }
          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];

    return (
      <ModalItem
        title={`Valores de: ${categoria.nombre} (${
          TIPO_DATO_LABEL[categoria.tipoDato] || categoria.tipoDato
        })`}
        visible={visible}
        spinning={this.state.loading}
        onCancel={this.props.onClose}
        paddingTop
        width={esNumero ? 800 : 700}
        footer={false}
      >
        {categoria.descripcion ? (
          <div
            style={{
              marginBottom: 10,
              padding: "8px 10px",
              background: "#f6faff",
              border: "1px solid #d6e4ff",
              borderRadius: 4,
              fontSize: 12,
              color: "#3b4a66",
            }}
          >
            {categoria.descripcion}
          </div>
        ) : null}
        <div
          style={{
            display: "flex",
            gap: 8,
            alignItems: "center",
            marginBottom: 8,
          }}
        >
          <SegmentedItem
            options={[
              { label: "Activos", value: 1 },
              { label: "Deshabilitados", value: 2 },
              { label: "Todos", value: 3 },
            ]}
            value={this.state.filtroEstado}
            onChange={(v) =>
              this.setState({ filtroEstado: v }, () => this.consultarValores())
            }
          />
        </div>
        {this.props.permisoAgregarValor && (
          <div
            style={{
              background: "#fafbfc",
              border: "1px solid #e8eaed",
              borderRadius: 6,
              padding: "10px 12px",
              marginBottom: 12,
            }}
          >
            <div
              style={{
                fontSize: 11,
                fontWeight: 600,
                color: "#6b7280",
                letterSpacing: "0.4px",
                textTransform: "uppercase",
                marginBottom: 8,
              }}
            >
              Nuevo valor
            </div>
            <div
              style={{
                display: "flex",
                gap: 10,
                alignItems: "flex-end",
              }}
            >
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    fontSize: 11,
                    color: "#6b7280",
                    marginBottom: 4,
                    fontWeight: 500,
                  }}
                >
                  Valor
                </div>
                {this.renderInputValor(this.state.nuevoValor, (v) =>
                  this.setState({ nuevoValor: v })
                )}
              </div>
              {esNumero && (
                <div style={{ width: 160 }}>
                  <div
                    style={{
                      fontSize: 11,
                      color: "#6b7280",
                      marginBottom: 4,
                      fontWeight: 500,
                    }}
                  >
                    Unidad (opcional)
                  </div>
                  <InputItem
                    value={this.state.nuevaUnidad}
                    onChange={(e) =>
                      this.setState({ nuevaUnidad: e.target.value })
                    }
                    placeholder="Ej. Mts, KG, V"
                  />
                </div>
              )}
              <ButtonItem
                type="primary"
                olivo
                icon={<PlusOutlined />}
                onClick={this.agregarValor}
              >
                Agregar
              </ButtonItem>
            </div>
          </div>
        )}

        <TableItem
          size="small"
          dataSource={this.state.valores}
          columns={columns}
          rowKey="_id"
          pagination={false}
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  permisoAgregarValor:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (v) => v.permisoId.toString() === "6a0c8ead95cdbbe290cdf82e"
    )?.activado,
  permisoEditarValor:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (v) => v.permisoId.toString() === "6a0c8ebb95cdbbe290cdf832"
    )?.activado,
  permisoHabDesValor:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (v) => v.permisoId.toString() === "6a0c8ecd95cdbbe290cdf844"
    )?.activado,
});

export default connect(mapStateToProps)(ModalValores);
